export const EVENT_OPEN_NOTIFICATION_DRAWER = "OPEN_NOTIFICATION_DRAWER";
export const EVENT_CLOSE_NOTIFICATION_DRAWER = "CLOSE_NOTIFICATION_DRAWER";
